import { ICategory } from "@eventr/common";
import { ColoursObj, Icon, TEventrIcons } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { getCategoryColours } from "utils";
import { useObjectContext } from "../providers/objectProvider";
import { CardText } from "../subComponents/cardText";

interface ParkingHeaderProps {
  name: string;
  category?: ICategory | undefined;
  visibility?: string;
}

export const ParkingHeader = ({ name, category, visibility }: ParkingHeaderProps) => {
  const { past } = useObjectContext();
  const iconColour = getCategoryColours(past, category);

  return (
    <Stack direction="row" sx={{
      justifyContent: "space-between"
    }}>
      <Stack direction="row" sx={{
        gap: "8px"
      }}>
        <Icon name={(category?.icon as TEventrIcons) ?? "Parking"} iconColour={iconColour} />
        <CardText variant="bodyBold">{name}</CardText>
      </Stack>
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "8px"
        }}>
        {visibility?.toLowerCase() === "private" && (
          <Icon
            height="16px"
            width="16px"
            name="Private"
            iconColour={past ? ColoursObj.shades.shade2 : ColoursObj.core.secondary}
          />
        )}
      </Stack>
    </Stack>
  );
};
